import { useEffect, useState } from "react";
import axios from "axios";
import { API_ENDPOINT, HEADER_TOKEN } from '../../constants/constants'
import MockTestCard from "./mockTestCard";
import { toast } from "react-toastify";
import MtReport from "./mtReport";

const DOW = ['S', 'M', 'T', 'W', 'T', 'F', 'S']
const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

const sameDay = (a, b) => a && b &&
    a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()

/* Flat month grid matching the handoff's "Filter · By date" panel. */
const DateFilter = ({ selected, onSelect }) => {
    const [view, setView] = useState(new Date(selected || new Date()))
    const year = view.getFullYear(), month = view.getMonth()
    const firstDow = new Date(year, month, 1).getDay()
    const daysInMonth = new Date(year, month + 1, 0).getDate()
    const today = new Date()

    const cells = []
    for (let i = 0; i < firstDow; i++) cells.push(null)
    for (let d = 1; d <= daysInMonth; d++) cells.push(d)

    const shift = (delta) => setView(new Date(year, month + delta, 1))

    return (
        <div style={{ background: 'var(--color-surface)', padding: 16 }}>
            <div style={{ fontSize: 10, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--color-accent)', marginBottom: 6 }}>Filter</div>
            <h4 style={{ margin: '0 0 12px' }}>By date</h4>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                <div style={{ flex: 1, fontSize: 13, fontWeight: 600 }}>{MONTH_NAMES[month]} {year}</div>
                <button className="btn btn-secondary" style={{ padding: '2px 8px' }} onClick={() => shift(-1)} aria-label="Previous month">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6" /></svg>
                </button>
                <button className="btn btn-secondary" style={{ padding: '2px 8px', marginLeft: 4 }} onClick={() => shift(1)} aria-label="Next month">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6" /></svg>
                </button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 3, fontSize: 11, textAlign: 'center' }}>
                {DOW.map((d, i) => <div key={`h${i}`} className="text-muted" style={{ padding: '4px 0' }}>{d}</div>)}
                {cells.map((n, i) => {
                    if (n === null) return <div key={`b${i}`} style={{ padding: '6px 0' }}></div>
                    const date = new Date(year, month, n)
                    const isSel = sameDay(date, selected)
                    const isToday = sameDay(date, today)
                    return (
                        <div
                            key={`d${i}`}
                            onClick={() => onSelect(date)}
                            className={isSel ? undefined : 'tyk-row-btn'}
                            style={{
                                padding: '6px 0', cursor: 'pointer',
                                background: isSel ? 'var(--color-accent)' : 'transparent',
                                color: isSel ? 'var(--color-bg)' : (isToday ? 'var(--color-accent)' : 'var(--color-text)'),
                                fontWeight: (isSel || isToday) ? 600 : 400,
                            }}
                        >{n}</div>
                    )
                })}
            </div>
            {selected && (
                <button className="btn btn-ghost" style={{ marginTop: 10, fontSize: 13 }} onClick={() => onSelect(null)}>Clear date filter</button>
            )}
        </div>
    )
}

const MockTests = () => {
    const PARENT = "parent"
    const REPORT = "report"
    const [currentView, setCurrentView] = useState(PARENT)
    const [cLink, setClink] = useState('')
    const [assessments, setAssessments] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [cdate, setCdate] = useState(null)
    const [searchQ, setSearchQ] = useState('')
    const [deletingLink, setDeletingLink] = useState(null)

    const createRedirect = () => { document.location.href = "/create-mocktest" }

    useEffect(() => { loadMocktest() }, [])

    function loadMocktest() {
        setIsLoading(true)
        axios.post(API_ENDPOINT + 'sam/get-mocktests', {}, HEADER_TOKEN).then(res => {
            setIsLoading(false)
            let d = res.data
            if (d.success) { setAssessments(d.message) } else { toast(d.message) }
        })
    }

    const onMockTestReport = (linkCode) => { setClink(linkCode); setCurrentView(REPORT) }

    // Remove a mock test from the public Mock tests page.
    const onMockTestDelete = (assessment) => {
        setDeletingLink(assessment.linkCode)
        axios.post(API_ENDPOINT + 'sam/delete-mocktest', { linkCode: assessment.linkCode }, HEADER_TOKEN).then(res => {
            setDeletingLink(null)
            const d = res.data
            if (d.success) {
                setAssessments(list => list.filter(a => a.linkCode !== assessment.linkCode))
                toast("Mock test deleted")
            } else {
                toast(d.message || "Couldn't delete the mock test")
            }
        }).catch(() => {
            setDeletingLink(null)
            toast("Couldn't delete the mock test")
        })
    }

    const visible = assessments.filter(a => {
        const q = searchQ.trim().toLowerCase()
        const matchesQ = !q || (a.title || '').toLowerCase().includes(q) || (a.category || '').toLowerCase().includes(q)
        const matchesDate = !cdate || (a.date && sameDay(new Date(a.date), cdate))
        return matchesQ && matchesDate
    })

    if (currentView !== PARENT) {
        return (
            <div>
                <button className="btn btn-secondary" style={{ marginBottom: 14 }} onClick={() => setCurrentView(PARENT)}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6" /></svg>Back
                </button>
                {cLink !== '' && <MtReport linkCode={cLink} />}
            </div>
        )
    }

    return (
        <div>
            {/* toolbar */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, height: 38, padding: '0 12px', background: 'var(--color-surface)', border: '1px solid var(--color-divider)', flex: 1, maxWidth: 320, color: 'var(--color-neutral-500)' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>
                    <input
                        value={searchQ}
                        onChange={e => setSearchQ(e.target.value)}
                        placeholder="Search assessments…"
                        style={{ border: 0, background: 'transparent', outline: 'none', font: 'inherit', fontSize: 13, color: 'var(--color-text)', width: '100%' }}
                    />
                </div>
                <div style={{ flex: 1 }}></div>
                <button className="btn btn-primary" onClick={createRedirect}>
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="M12 5v14" /></svg>Create Mocktest
                </button>
            </div>

            <div style={{ display: 'flex', gap: 20 }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {isLoading && <div className="text-muted" style={{ fontSize: 13 }}>Loading assessments…</div>}
                    {visible.map((assessment, i) => (
                        <MockTestCard
                            key={assessment.linkCode || i}
                            onReport={onMockTestReport}
                            onDelete={onMockTestDelete}
                            deleting={deletingLink === assessment.linkCode}
                            assessment={assessment}
                        />
                    ))}
                    {!isLoading && visible.length === 0 && (
                        <div style={{ background: 'var(--color-surface)', padding: 40, textAlign: 'center' }}>
                            <h4 style={{ margin: '0 0 4px' }}>{assessments.length === 0 ? 'No assessments yet' : 'No matching assessments'}</h4>
                            <p style={{ fontSize: 13, margin: '0 0 16px' }} className="text-muted">
                                {assessments.length === 0 ? 'Create your first mocktest to get started.' : 'Try a different search or clear the date filter.'}
                            </p>
                            {assessments.length === 0 && (
                                <button className="btn btn-primary" onClick={createRedirect}>
                                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="M12 5v14" /></svg>Create Mocktest
                                </button>
                            )}
                        </div>
                    )}
                </div>
                <div style={{ width: 280, flex: 'none' }}>
                    <DateFilter selected={cdate} onSelect={setCdate} />
                </div>
            </div>
        </div>
    )
}
export default MockTests
